<div class="alert-backdrop" *ngIf="alert$ | async as alert">

  <div class="alert-box" [ngClass]="alert.type">

    <button class="close-btn" (click)="close()">&times;</button>

    <p>{{ alert.message }}</p>

    <div class="actions">

      <div *ngIf="alert.type !== 'info' && alert.type !== 'confirm'">
        <button class="btn-primary" (click)="close()">OK</button>
      </div>

      <div *ngIf="alert.type === 'confirm'">
        <button class="btn-secondary" (click)="close()">Cancelar</button>
        &nbsp;&nbsp;
        <button class="btn-primary" (click)="confirm()">Confirmar</button>
      </div>

    </div>

  </div>

</div>